var map = {
	"./blackBishop.jpg": 914,
	"./blackKing.jpg": 301,
	"./blackKnight.jpg": 585,
	"./blackPawn.jpg": 717,
	"./blackQueen.jpg": 795,
	"./blackRook.jpg": 662,
	"./whiteBishop.jpg": 642,
	"./whiteKing.jpg": 300,
	"./whiteKnight.jpg": 1,
	"./whitePawn.jpg": 668,
	"./whiteQueen.jpg": 760,
	"./whiteRook.jpg": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;